import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";

const BasicCompanyData = props => {
  const { userData } = props.parentState.newFormData;
  const { oibValidated } = userData;
  return (
    <>
      <Row>
        <Col>
          <InputComponent
            disabled={props.disabled}
            required={props.required}
            style={
              props.required &&
              props.parentState.error &&
              userData.oib.length < 1 &&
              "red"
            }
            id={"oib-user-data"}
            name="oib"
            minLength={11}
            maxLength={11}
            onChange={props.userInputHandler}
            objData={{ group: "userData" }}
            value={userData.oib}
            controlLabel={"OIB društva"}
          />
          {!oibValidated &&
            userData.oib.length <= 11 &&
            userData.oib.length > 0 && (
              <p style={{ color: "red" }}>Oib nije ispravan!</p>
            )}
        </Col>
        <Col>
          <InputComponent
            required={props.required}
            style={
              props.required &&
              props.parentState.error &&
              userData.nazDrustva.length < 1 &&
              "red"
            }
            id={"naziv-drustva-user-data"}
            name="nazDrustva"
            onChange={props.userInputHandler}
            objData={{ group: "userData" }}
            value={userData.nazDrustva}
            controlLabel={"Naziv društva"}
          />
        </Col>
      </Row>
    </>
  );
};

export default BasicCompanyData;
